var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":"signature-pad","width":"400","height":"200"}}),_c('button',{on:{"click":_vm.clearCanvas}},[_vm._v("Limpar")]),_c('button',{on:{"click":_vm.saveSignature}},[_vm._v("Salvar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }